import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchData } from "@/utils/api-handler";
import { MAX_API_PAGE_LIMIT } from "@/utils/global";

interface RoleState {
  list: RoleData[];
  scopes: Scope[];
}

export const fetchRoles = createAsyncThunk(
  "roles/fetchRoles",
  (): Promise<RoleData[]> =>
    fetchData(`/api/rbac/roles?page=1&limit=${MAX_API_PAGE_LIMIT}`)
);

const initialState: RoleState = { list: [], scopes: [] };

export const roleSlice = createSlice({
  name: "roles",
  initialState,
  reducers: {
    setRoles: (state, action: PayloadAction<RoleData[]>) => {
      state.list = action.payload;
    },
    setScopes: (state, action: PayloadAction<Scope[]>) => {
      state.scopes = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchRoles.fulfilled, (state, action) => {
      state.list = action.payload;
    });
  },
});

export const { setRoles, setScopes } = roleSlice.actions;
export default roleSlice.reducer;
